// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { Settings } from "src/app/modules/common/lib/app.constant";

export const environment = {
  production: false,
  isCozentusEnvironment : true,
  environmentType:Settings.EnvironmentType.DEV,
  // baseApiUrl:'https://freight-audit-api-dev.azurewebsites.net/api/',
   // baseApiUrl:'https://freightaudit-api-test.azurewebsites.net/api/',
   baseApiUrl:'https://freightaudit-api-dev.azurewebsites.net/api/',
  // baseApiUrl:'http://192.168.0.218:8000/api/',
  // baseApiUrl:'http://192.168.1.197:8899/api/',
  appInsights: {
    instrumentationKey: null
  },

  //need to use this inside interceptor and app.main.component.ts
  client_sso: {
    // cozentus
    cozentus:{
      sso:{
        adClientId:'e750ec39-3720-406b-b20c-0aa0005c56a1',
        adTenantId : 'cd3779f6-2af9-4aee-be9a-45e131119f0b',
        scopes: ['e750ec39-3720-406b-b20c-0aa0005c56a1/api-access']
      },
      msalLogInRequest : ['api://e750ec39-3720-406b-b20c-0aa0005c56a1/api-access'],
    },
    // bridgenet
    bridgenet: {
      sso:{
        adClientId:'8144c81a-963c-49bc-87a7-105662741a73',
        adTenantId : '209cf566-fd1d-4eea-bd48-498e77253a06',
        scopes: ['8144c81a-963c-49bc-87a7-105662741a73/api-access']
      },
      msalLogInRequest : ['api://8144c81a-963c-49bc-87a7-105662741a73/api-access']
    } 
  }
};
